import actions from '@/core/store/arquivo-temporario/actions'

export default { actions }
